<template>
    <div class="mdl-grid">
        <input :disabled="disabled" class="mdl-cell mdl-cell--2-col-desktop mdl-cell--5-offset-desktop mdl-shadow--4dp picker" type="date" name="day" v-model="date">
        <button :disabled="disabled" class="mdl-button mdl-shadow--2dp" style="margin-top: auto; margin-bottom: auto" v-on:click="setToday()">Dnes</button>
    </div>
</template>

<script>
    export default {
        name: "DatePicker",
        props: { datum: Date, disabled: Boolean },
        data: function () {
            return {
                date: new Date().toISOString().substr(0, 10)
            }
        },
        methods: {
            setToday: function() {
                this.date = new Date().toISOString().substr(0, 10);
            }
        },
        watch: {
            // eslint-disable-next-line no-unused-vars
            date: function (oldVal, newVal) {
                this.$emit('date-change', this.date);
            },
            // eslint-disable-next-line no-unused-vars
            datum: function (oldVal, newVal) {
                this.date = this.datum.toISOString().substr(0, 10);
            }
        }
    }
</script>

<style scoped>
    .picker {
    }

    input[type="date"]::-webkit-clear-button {
        display: none;
    }

    input[type="date"] {
        -webkit-appearance: none;
        color: #666666;
        font-size: 18px;
        border: 0;
        background: white;
        padding:5px;
        display: inline-block !important;
        visibility: visible !important;
        border-radius: 0.5rem;
    }

    input[type=date]:focus, textarea:focus {
        outline:0;
    }

</style>